import mixpanel from 'mixpanel-browser'
import keys from './MixPanelKeys'
import env from '../../../config/env'

class MixPanel {
  userInformation:
    | {
        $name: string
        $familyName: string
        $phoneNumber: string
        $tenantId: string
        $language: string
      }
    | undefined
  keys: Record<string, string>

  constructor() {
    this.userInformation = undefined
    this.keys = keys
  }

  async init() {
    try {
      mixpanel.init(env.MixPanelToken)
    } catch (err) {
      console.error(err)
    }
  }

  identify(id: string) {
    mixpanel.identify(id)
  }

  track(name: string = '', data: any = {}, includeUserData = false) {
    try {
      mixpanel.track(name, {
        ...data,
        ...(includeUserData && (this.userInformation || {})),
      })
    } catch (err) {
      console.error(err)
    }
  }

  setPeople(props: Record<string, string>) {
    mixpanel.people.set(props)
  }

  initializeUser({ id, name, familyName, phoneNumber, tenantId, language }: Record<string, string>) {
    try {
      // set user information to use in another function
      this.userInformation = {
        $name: name || '',
        $familyName: familyName || '',
        $phoneNumber: phoneNumber || '',
        $tenantId: tenantId || '',
        $language: language || '',
      }

      this.identify(id || '')
      this.setPeople({
        $name: name || '',
        $familyName: familyName || '',
        $phoneNumber: phoneNumber || '',
        $tenantId: tenantId || '',
        $language: language || '',
      })
    } catch (err) {
      console.error(err)
    }
  }
}

export default new MixPanel()
